export interface SystemNotification {
    id: number;
    type: SystemNotificationType;
    email: string;
}

export enum SystemNotificationType {
    ImportFinished = 'IMPORT_FINISHED',
    NewSingleInquiry = 'NEW_SINGLE_INQUIRY',
    DeleteCustomerEmployeeWithTags = 'DELETED_CUSTOMER_EMPLOYEE_WITH_TAGS',
    DeleteSupplierEmployeeWithTags = 'DELETED_SUPPLIER_EMPLOYEE_WITH_TAGS',
}
